import { View, Text, Link } from "@react-pdf/renderer";
import { styles } from "../MemberDetailsStyle";

export default function ThirdRow({ item, translate }) {
  return (
    <View style={styles.thirdRow.self}>
      <View style={styles.thirdRow.left.self}>
        {item.specialisation_details?.phone?.length > 0 && (
          <View style={styles.thirdRow.left.contact}>
            <Link style={styles.link} src={`tel:${item.specialisation_details.phone}`}>
              T {item.specialisation_details.phone}
            </Link>
          </View>
        )}
        {item.specialisation_details?.mobile?.length > 0 && (
          <View style={styles.thirdRow.left.contact}>
            <Link style={styles.link} src={`tel:${item.specialisation_details.mobile}`}>
              M {item.specialisation_details.mobile}
            </Link>
          </View>
        )}
        {item.specialisation_details?.email?.length > 0 && (
          <View style={styles.thirdRow.left.contact}>
            <Link style={styles.link} src={`mailto:${item.specialisation_details.email}`}>
              {item.specialisation_details.email}
            </Link>
          </View>
        )}
        {item.specialisation_details?.website?.length > 0 && (
          <View style={styles.thirdRow.left.contact}>
            <Link style={styles.link} src={`${item.specialisation_details.website}`}>
              {item.specialisation_details.website}
            </Link>
          </View>
        )}
      </View>
      <View style={styles.thirdRow.right.self}>
        <Text style={styles.thirdRow.right.block_title}>{translate("directory.member.info.label.activities")}</Text>

        <View style={{ ...styles.flex_container.self, ...styles.flex_container.wrap }}>
          {item.specialisation_details.specialisations.map((e, i) => (
            <Text key={i} style={{ ...styles.flex_container.fit_content, ...styles.curved_borders, ...styles.tertiary }} wrap={false}>
              {e}
            </Text>
          ))}
          <Text key={"empty"} style={styles.flex_container.empty_item}></Text>
        </View>
        <View wrap={false}>
          <Text style={{ ...styles.thirdRow.right.block_title, ...styles.marginTop }}>{translate("directory.member.info.label.lanuage")}</Text>
          <View style={{ ...styles.flex_container.self, ...styles.flex_container.wrap }}>
            {item.specialisation_details.specialist_languages.map((e, i) => (
              <Text key={i} style={{ ...styles.flex_container.fit_content, ...styles.curved_borders, ...styles.tertiary }}>
                {e}
              </Text>
            ))}
            <Text key={"empty"} style={styles.flex_container.empty_item}></Text>
          </View>
        </View>
      </View>
    </View>
  );
}
